interface Thread {
	_id: string
}

export default function getIndexOfThreads(
	threadId: string,
	threads: Thread[],
): number {
	return threads.findIndex((thread) => thread._id === threadId)
}
